import * as React from 'react';
import { SVGProps } from 'react';

const IconMaxWidthSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 12.444V20H2V4h2v7.556L8 8v3h8V8l4 3.556V4h2v16h-2v-7.556L16 16v-3H8v3l-4-3.556z" />
  </svg>
);
export default IconMaxWidthSizeM;
